<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form ref="form" :model="query" label-width="80px" inline size="mini">
      <el-form-item label="用户标识">
        <el-input v-model="query.sourceUuid" clearable placeholder="请输入用户ID"></el-input>
      </el-form-item>
      <el-form-item label="反馈状态">
        <el-select v-model="query.status" clearable placeholder="请选择反馈状态">
          <el-option label="新反馈" value="0"></el-option>
          <el-option label="已解决" value="1"></el-option>
          <el-option label="未解决" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 数据展示区域 -->
      <el-table :data="opinionList" style="width: 100%" height="650px" stripe border>
        <el-table-column prop="sourceUuid" label="用户ID" width="160"></el-table-column>
        <el-table-column prop="sourceType" label="用户类型" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.sourceType === 1">普通用户</span>
            <span v-if="scope.row.sourceType === 2">代理</span>
            <span v-if="scope.row.sourceType === 3">商家</span>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentUuid" label="设备SN码" width="160"></el-table-column>
        <el-table-column prop="imageUrl" label="故障预览" width="100">
          <template slot-scope="scope">
            <el-image style="width: 100%; height: 75px" :src="scope.row.imageUrl[0]" :preview-src-list="scope.row.imageUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="反馈内容"></el-table-column>
        <el-table-column prop="remark" label="处理备注" width="200"></el-table-column>
        <el-table-column label="反馈状态" width="80">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.status === 0">新反馈</el-tag>
            <el-tag type="success" v-else-if="scope.row.status === 1">已解决</el-tag>
            <el-tag type="info" v-else>未解决</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="warning" size="small" @click="deal(scope.row.uuid)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="curPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 处理意见反馈对话框 -->
    <el-dialog title="处理意见反馈" :visible.sync="opinionDialogVisible" @close="close('opinionFormRef')" width="30%">
      <el-form ref="opinionFormRef" :model="opinionForm" :rules="opinionRules" label-width="120px">
        <el-form-item label="处理结果" prop="status">
          <el-select v-model="opinionForm.status" placeholder="请选择处理结果">
            <el-option label="已解决" value="1"></el-option>
            <el-option label="未解决" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理备注" prop="remark">
          <el-input v-model="opinionForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="opinionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dealSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片未渲染 -->
  </div>
</template>

<script>
import { opinionList, editOpinion } from '@/API/opinion'
export default {
  name: 'opinion',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        contactor: '',
        cellphone: '',
        sourceUuid: '',
        sourceType: '',
        status: ''
      },
      //   意见反馈数据
      opinionList: [],
      //   数据总条数
      total: 0,
      // 处理意见反馈对话框
      opinionDialogVisible: false,
      // 处理意见反馈表单数据
      opinionForm: {
        uuid: '',
        status: '',
        remark: ''
      },
      opinionRules: {
        status: [{ required: true, message: '请选择处理结果', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入处理备注', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getOpinionList()
  },
  methods: {
    // 获取意见反馈数据
    async getOpinionList() {
      const { data: res } = await opinionList(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.opinionList = res.data.entities
      this.total = res.data.totalSize
    },
    // 搜索按钮点击触发
    seach() {
      this.query.curPage = 1
      this.getOpinionList()
    },
    // 重置按钮点击触发
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.getOpinionList()
    },
    // 处理意见反馈
    deal(uuid) {
      this.opinionForm.uuid = uuid
      this.opinionDialogVisible = true
    },
    // 处理意见反馈提交
    async dealSubmit() {
      this.$refs.opinionFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await editOpinion(this.opinionForm)
        if (res.code === 200) {
          this.$message.success(res.message)
          this.$refs.opinionFormRef.resetFields()
          this.opinionDialogVisible = false
          this.getOpinionList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getOpinionList()
    },
    // 监听curPage
    curPageChange(newPage) {
      this.query.curPage = newPage
      this.getOpinionList()
    },
    close(formRef) {
      this.$refs[formRef].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.el-form {
  .el-input {
    width: 180px;
  }
  .el-select {
    width: 180px;
  }
  .custodyBtn {
    margin-left: 60px;
  }
}
.el-pagination {
  margin-top: 30px;
}
.el-card__body {
  padding: 0;
  .el-form-item {
    margin: 0;
    margin: 0;
    width: 33%;
  }
  .uuidBox {
    position: relative;
    cursor: pointer;
  }
  .el-pagination {
    padding-top: 20px;
  }
}
</style>
